__webpack_require__.p = "/new-kviz-2023/build/";